require('../scss/style.scss')

requireAll(require.context('./slick-runners/', false, /\.(js)$/))
requireAll(require.context('./chunks/', false, /\.(js)$/))

function requireAll (r) { r.keys().forEach(r) }
